<template>
    <div>
        <control :label="'Payment ' + (index + 1) + ' Date'" :no-flex-margin="true">
            <date-input v-model="date"
                        name="date"
                        required
                        v-field-control
                        @input="updateInterest"></date-input>
            <control-error :show="!isValidDate() || $error('date')">
                Date is required, must be in the format DD/MM/YYYY and must be after the claimant's
                onset of symptoms {{ onsetOfSymptoms }}
            </control-error>
            <control-error :show="!isBeforeInterestDate()">
                Date must be before interest date ({{ interestDate }})
            </control-error>
        </control>
        <br>
        <control label="Amount" for="value" before-after="pound">
            <input autocomplete="off" v-model.number="value"
                   v-field-control
                   required
                   :max="remainingTotal"
                   min="1"
                   v-on:focus="value = value || ''"
                   v-on:blur="value = value || 0"
                   v-two-dp
                   @input="updateInterest"
                   name="value"
                   type="number">
            <control-error :show="$error('value')">
                The amount must be at least &pound;1.00 and less than the total past heads of loss
                {{ currencyFormat(getHeadsOfLossTotalMinusInterest) }} - remaining total {{ currencyFormat(remainingTotal) }}
            </control-error>
        </control>
        <button class="a-button" @click="deleteThisPayment">Delete This Payment</button>
    </div>
</template>

<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import FormValidator from 'components/form/validator/mixin';
    import {mapGetters, mapActions} from 'vuex';
    import {setStepValid} from 'services/routingMethods';
    import moment from "moment";
    import store from 'store/index';
    import currencyFormat from 'mixins/currencyFormat';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    const numberVal = value => parseFloat(value || 0);

    export default {
        name: 'payment',
        props: {
            index: {
                type: Number,
                required: true
            }
        },
        components: {
            Control,
            ControlError,
            DateInput
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        mixins: [
            FormValidator,
            currencyFormat
        ],
        computed: {
            ...mapGetters('lost/headsOfLoss', ['getHeadsOfLossValue', 'interestDate', 'getHeadsOfLossTotalMinusInterest']),
            ...mapGetters('lost/interimPayments', ['findPayment', 'allInterimPaymentsValid']),
            ...mapGetters('lost/claimant', ['getClaimantValue']),
            onsetOfSymptoms: {
                get() {
                    return this.getClaimantValue('onsetOfSymptoms');
                },
            },
            date: {
                get() {
                    return this.findPayment(this.index).date
                },
                set(value) {
                    this.updatePayment({key: 'date', index: this.index, value})
                        .then(this.updateValid.bind(this));
                }
            },
            value: {
                get() {
                    return this.findPayment(this.index).value
                },
                set(value) {
                    this.updatePayment({key: 'value', index: this.index, value})
                        .then(this.updateValid.bind(this));
                }
            },
            remainingTotal() {
                return numberVal(
                    this.getHeadsOfLossTotalMinusInterest -
                    store.getters['lost/interimPayments/interimPayments'].reduce((total, payment) => total + payment.value, 0) +
                    this.value
                )
            },
        },
        methods: {
            ...mapActions('lost/interimPayments', [
                'updatePayment',
                'deletePayment'
            ]),
            ...mapActions('lost/headsOfLoss', [
                'calcAllInterest'
            ]),
            deleteThisPayment() {
                this.deletePayment(this.index);
                setStepValid(this.allInterimPaymentsValid);
                this.updateInterest();
            },
            updateInterest() {
                this.$emit('update');
                this.calcAllInterest();
            },
            updateValid() {
                setStepValid(this.allInterimPaymentsValid);
            },
            isValidDate() {
                if (!this.date) {
                    return true;
                }

                return (
                    moment(this.date, 'DD/MM/YYYY').isAfter(moment(this.onsetOfSymptoms, 'DD/MM/YYYY'))
                );
            },
            isBeforeInterestDate() {
                if (!this.date || !this.interestDate) {
                    return true;
                }

                let mInterestDate = moment(this.interestDate, 'DD/MM/YYYY');

                if (!mInterestDate.isValid()) {
                    return true;
                }

                return moment(this.date, 'DD/MM/YYYY').isBefore(mInterestDate);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Payment.vue?f8fa43ea